if (!customElements.get('imprint-3d-modal')) {
  customElements.define(
    'imprint-3d-modal',
    class Imprint3dModal extends ModalDialog {
      constructor() {
        super();

        this.submitButton = this.querySelector('.imprint-3d-modal_content-footer-button-wrapper .product-form__submit');
        this.overlay = document.querySelector('.imprint-3d-modal-overlay');
        this.overlay?.addEventListener('click', this.handleModalClose.bind(this));

        this.setButtonState = this.setButtonState.bind(this);
        this.handleModalClose = this.handleModalClose.bind(this);

        this.addEventListener('change', (e) => {
          if (e.target.matches('#imprint-3d-modal-checkbox')) {
            this.setButtonState(e.target.checked);
          }
        });

        this.addEventListener('modalClosed', this.handleModalClose);
        this.addEventListener('click', (e) => {
          if (e.target.closest('.modal-close')) this.handleModalClose();
        });
      }

      setButtonState(enabled = false) {
        const checkbox = this.querySelector('#imprint-3d-modal-checkbox');
        const submitButton = this.querySelector(
          '.imprint-3d-modal_content-footer-button-wrapper .product-form__submit'
        );

        if (checkbox) checkbox.checked = enabled;

        if (submitButton) {
          submitButton.disabled = !enabled;
          submitButton.setAttribute('aria-disabled', String(!enabled));

          if (enabled) {
            submitButton.removeAttribute('disabled');
          } else {
            submitButton.setAttribute('disabled', 'disabled');
          }
        }
      }

      handleModalClose() {
        this.setButtonState(false);
        this.overlay?.classList.remove('show');
      }

      show(opener) {
        super.show(opener);
        this.setButtonState(false);
      }

      hide() {
        super.hide();
        this.handleModalClose();
      }
    }
  );
}
